export class IWorldObject {
    constructor(context) {
        if (this.context === undefined) {
            this.context = null;
        }
        this.context = context;
    }
}
IWorldObject['__class'] = 'de.coco.mindLinq.world.IWorldObject';
